import * as actions from './actions';
import reducer from './reducer';
import * as schemas from './schemas';
import * as selectors from './selectors';
import namespace from './types';

export {
    actions,
    schemas,
    selectors,
};

export default {
    [namespace]: reducer,
};
